import type { ProfileGender } from '@/features/profile/edit/types';

export const PROFILE_BIO_MAX_LENGTH = 150;

export const PROFILE_GENDER_OPTIONS: readonly { value: ProfileGender; label: string }[] = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'non_binary', label: 'Non-binary' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
] as const;
